import {connect} from "react-redux";
import AccountList from "./list";
import {bindActionCreators} from "redux";
import {accountDetails, getFilter, getCityByStateId} from "../../../service/Account/action";

const mapStateToProps = (state) => ({
    accountList:state.Dropdown.accountDetails,
    accountFilterContent:state.Dropdown.accountFilterContent,
    geoCity:state.Dropdown.geoCity,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            accountDetails,
            getFilter,
            getCityByStateId
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AccountList);
